"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _NavigateBackButton = require("@ccw-pwa-ui/NavigateBackButton");
var _HeaderText = require("@ccw-pwa-ui/HeaderText");
var _ConnectionLoader = require("@ccw-pwa-ui/ConnectionLoader");
var _react = _interopRequireDefault(require("react"));
var _reactDatepicker = _interopRequireDefault(require("react-datepicker"));
require("../../styles/AddAccessoryInstallationComponent.css");
var _Button = require("@ccw-pwa-ui/Button");
var _index = _interopRequireDefault(require("../../common_features/assets/images/index"));
var _Modal = _interopRequireDefault(require("@ccw-pwa-ui/Modal/lib/Modal"));
const AddAccessoryInstallationComponent = _ref => {
  let {
    totalPage,
    currentPage,
    navHeading,
    rightNavHeading,
    handleCancle,
    handleBack,
    headerText,
    list,
    preText,
    installationText,
    dateChange,
    bottomBtnTitle,
    navigateToProvisioningDevice,
    noQrDisabled,
    modelNumber,
    isLoading,
    displayModal,
    modalHeaderText,
    variant,
    positiveActionButtonTitle,
    negativeButtonActionTitle,
    positiveAction,
    displayErrorModal,
    modalHeaderErrorText,
    modalDetailText,
    modalDetailText3,
    modalErrorDetailText,
    retryButtonTitle,
    cancelButtonTitle,
    cancelButtonClick,
    retryButtonClick,
    variantError,
    minDate,
    pageNumberNotShow
  } = _ref;
  return isLoading ? /*#__PURE__*/_react.default.createElement(_ConnectionLoader.ConnectionLoader, null) : /*#__PURE__*/_react.default.createElement("div", {
    className: "accessoryInst-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_NavigateBackButton.NavigateBackButton, {
    navHeading: navHeading,
    rightNavHeading: rightNavHeading,
    handleCancle: handleCancle,
    handleBack: handleBack,
    leftArrowImage: _index.default.leftArrow.default
  }), !pageNumberNotShow ? /*#__PURE__*/_react.default.createElement("div", {
    className: "PageCount"
  }, /*#__PURE__*/_react.default.createElement("span", {
    style: {
      fontWeight: 600
    }
  }, "Step ", currentPage, " "), " of ", totalPage) : null, /*#__PURE__*/_react.default.createElement("div", {
    className: "accessoryInst-body-wrapper"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "accessoryInst-body"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: !pageNumberNotShow ? "addAccessory-heading" : "addAccessory-heading-2"
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    variant: "header-text",
    headerText: headerText
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "addAccessory-subContent"
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    variant: "sub-text",
    headerText: preText
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "model-number-label"
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerText: modelNumber
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "accessoryInst-datePicker-Wrapper"
  }, list === null || list === void 0 ? void 0 : list.map(item => {
    var _item$ModelNumber;
    return /*#__PURE__*/_react.default.createElement("div", {
      key: item["Model Number"],
      className: "accessoryInst-datePicker"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "edit-input-label"
    }, (_item$ModelNumber = item["Model Number"]) === null || _item$ModelNumber === void 0 ? void 0 : _item$ModelNumber.slice(2)), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
      className: "edit-input-label"
    }, installationText), /*#__PURE__*/_react.default.createElement("div", {
      className: "edit-accessory-date-picker",
      "data-testid": "edit-accessory-date-picker"
    }, /*#__PURE__*/_react.default.createElement(_reactDatepicker.default, {
      placeholderText: "Select",
      className: "edit-accessory-date",
      selected: item.selectedDate,
      onChange: date => dateChange(date, item["Model Number"]),
      minDate: minDate,
      maxDate: new Date()
    }), /*#__PURE__*/_react.default.createElement("img", {
      src: _index.default.Union.default,
      alt: "",
      className: "email-icon2"
    }))));
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "accessoryInst-btn"
  }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    variant: "primary-long",
    title: bottomBtnTitle,
    onClick: navigateToProvisioningDevice,
    disabled: noQrDisabled
  })))), displayModal && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Modal.default, {
    displayModal: displayModal,
    modalHeaderText: modalHeaderText,
    modalHeaderTextStyle: {
      color: "#4F8309",
      fontFamily: "Poppins"
    },
    modalDetailText: modalDetailText,
    modalDetailText3: modalDetailText3,
    modalDetailTextStyle: {
      fontSize: 16,
      color: '#333333',
      fontWeight: 400,
      lineHeight: "22px",
      fontFamily: "Poppins",
      marginBottom: "10px"
    },
    variant: variant,
    positiveActionButtonTitle: positiveActionButtonTitle,
    positiveAction: positiveAction,
    negativeButtonActionTitle: negativeButtonActionTitle
  })), displayErrorModal && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Modal.default, {
    displayModal: displayErrorModal,
    modalHeaderText: modalHeaderErrorText,
    modalHeaderTextStyle: {
      color: "#E00932",
      fontFamily: "Poppins"
    },
    modalDetailText: modalErrorDetailText,
    modalDetailTextStyle: {
      fontSize: 16,
      color: '#333333',
      fontWeight: 400,
      lineHeight: "22px",
      fontFamily: "Poppins",
      marginBottom: "10px"
    },
    variant: variantError,
    positiveActionButtonTitle: retryButtonTitle,
    positiveAction: retryButtonClick,
    negativeButtonActionTitle: cancelButtonTitle,
    negativeAvtion: cancelButtonClick
  })));
};
var _default = exports.default = AddAccessoryInstallationComponent;